import ButtonLink from "./button-link";
import classes from "../classes";
import expandable from "./higher-order/expandable";
import FormattedCurrency from "./formatted-currency";
import pure from "./higher-order/pure";
import React from "react";
import { ordinal } from "../ordinal";

const payoutsToShow = 10;

export default pure(expandable(({ expanded, payouts, toggle, tournament }) => {
  var items = Object.keys(payouts).map((place, i) => {
    var payout = payouts[place];
    return (
      <dl
        className={classes({
          "tournament-table_payout-row": true,
          "tournament-table_payout-row--is-hidden": !expanded && i >= payoutsToShow
        })}
        key={place}>
        <dt>
          {ordinal(place)}
        </dt>

        <dd>
          <FormattedCurrency
            dollarsValue={payout.dollars}
            pointsValue={payout.points}
            tokenName={payout.tokenName}
            tokenValue={payout.tokenValue} />
        </dd>
      </dl>
    );
  });
  var bankRollInfo;
  var toggleLink;
  if (Object.keys(payouts).length > payoutsToShow) {
    toggleLink = (
      <ButtonLink className="tournament-table_payout-toggle" onClick={(e) => {e.stopPropagation(); toggle(); }}>
        Show
        {expanded ? "Fewer" : "All"}

        {" "}
        Payouts
      </ButtonLink>
    );
  }
  if (tournament.get("real_money")) {
    bankRollInfo = (
      <div className="color--is-lime text--is-bold text--is-italic">
        Plus, you keep your remaining
        <br />

        bankroll at the end!
      </div>
    );
  }
  return (
    <dl className="tournament-table_meta_item">
      <dt>
        Prize Distribution:
      </dt>

      <dd>
        <div className="tournament-table_payout-table">
          {items}
        </div>

        {bankRollInfo}

        {toggleLink}
      </dd>
    </dl>
  );
}
));
